import { sanitizeHtml } from '../domain/sanitize';

interface Props {
  html: string | null | undefined;
  as?: 'span' | 'div' | 'p';
  className?: string;
}

/** Tenant-authored HTML (labels, paragraphs) through the allow-list sanitizer. */
export function Html({ html, as = 'span', className }: Props) {
  if (!html) return null;
  const Tag = as;
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />;
}
